import React, {useState, useEffect} from 'react';

import {Container, Row} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";


import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import AuthService from "../util/AuthService";
import FullCalendarHome from "./FullCalendarHome";
import ApiService from "../util/ApiService";
import "react-loading-skeleton/dist/skeleton.css";
import errorImage from "./../../assets/img/505.png";
import {useDispatch} from "react-redux";



import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changePreLoader,
    changeSidebarVisibility
    // resetValue
} from "../../../slices/thunks";

const Dashboard = () => {
    // const dispatch = useDispatch();

    document.title = "Dashboard | Plantão Rápido";
    const user = AuthService.getUserData();

    const [loading, setLoading] = useState(true); // Estado para o carregamento


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Home" pageTitle="Dashboards"/>
                    <Row>
                        {user.companies?.length == 0 && user.users_type_id == 3 ? (
                            <>
                                <div className="error-page"
                                     style={{textAlign: 'center', padding: '50px', backgroundColor: '#F8F9FA'}}>
                                    <div className="main-wrapper" style={{
                                        margin: '0 auto',
                                        maxWidth: '80%',
                                        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                                        borderRadius: '8px',
                                        padding: '30px',
                                        backgroundColor: '#FFF'
                                    }}>
                                        <div className="row">
                                            <div className="col-7">
                                                <img
                                                    src={errorImage}
                                                    alt="Erro 505"
                                                    style={{width: '350px', marginBottom: '20px'}}
                                                />
                                            </div>
                                            <div className="col-5">

                                                <h1 className="text-primary "
                                                    style={{
                                                        fontSize: '28px',
                                                        color: '#0096D1',
                                                        marginTop: '70px',
                                                        marginBottom: '10px'
                                                    }}>
                                                    Nenhuma Empresa Cadastrada
                                                </h1>
                                            </div>
                                        </div>
                                        <h3 style={{fontSize: '18px', color: '#5F6368', marginBottom: '10px'}}>
                                            No momento, não encontramos empresas atribuídas ao seu perfil para
                                            gerenciamento.
                                        </h3>
                                        <p style={{fontSize: '16px', color: '#5F6368', marginBottom: '20px'}}>
                                            Se você esperava ver alguma empresa, entre em contato com o administrador do
                                            sistema.<br/>
                                            Nossa equipe está à disposição para ajudar!
                                        </p>
                                        <a href="/admin/help-desk" className="btn btn-outline-secondary"
                                           style={{padding: '10px 20px', borderRadius: '5px'}}>
                                            Fale com o Suporte
                                        </a>
                                    </div>
                                </div>
                            </>


                        ) : (
                            <>
                                {/* Adiciona o componente de carrossel na página principal */}
                                <div className="row">

                                    <FullCalendarHome/>
                                </div>
                            </>
                        )}


                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Dashboard;
